// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._58eabc{min-width:20em}.b4e697{display:flex;gap:.375em;align-items:baseline;margin:.5em 0;font-size:1.375em;justify-content:center}.b4e697>small{font-size:.6em;opacity:.75}._2d4919{margin:1.25em 0}", ""]);
// Exports
exports.locals = {
	"popup": "_58eabc",
	"time": "b4e697",
	"centered": "_2d4919"
};
module.exports = exports;
